export default from './SelectQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/SelectQuestion/index.js